const initialState = {
  scatterChart:
  {
xAxis: "Durchschnittliche Eigenschaft",
yAxis: "Anz. eingeteilt an Lieblingsstandort",
  },
  fetchModelDataPending: false,
  fetchModelDataError: null,
  saveSchedulePending: false,
  saveScheduleError: null,
  optimizeSchedulePending: false,
  optimizeScheduleError: null,
  clearSchedulePending: false,
  clearScheduleError: null,
  startSchedulingPending: false,
  startSchedulingError: null,
  readSchedulingResultPending: false,
  readSchedulingResultError: null,
  publishAssignmentsPending: false,
  publishAssignmentsError: null,
  savePlansPending: false,
  savePlansError: null,
  createSeasonPending: false,
  createSeasonError: null,
  deleteSeasonPending: false,
  deleteSeasonError: null,
  syncPlansWithPcoPending: false,
  syncPlansWithPcoError: null,
  saveSeasonPending: false,
  saveSeasonError: null,
  fetchSchedulePending: false,
  fetchScheduleError: null,
  syncWorkersWithPcoPending: false,
  syncWorkersWithPcoError: null,
  fetchMissingPropertiesPending: false,
  fetchMissingPropertiesError: null,
  createSchedulePending: false,
  createScheduleError: null,
  fetchEmailPending: false,
  fetchEmailError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js